import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Account } from '../../../../models/customer';
import { SinglePaymentRouteSettings } from '../../../../models/single-payment/single-payment-route-settings';
import { SelectedAccountsSettings } from '../selected-accounts-settings';

@autoinject
export class CardSinglePayment {
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;

	constructor(private router: Router) {
	}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.selectedAccountsSettings = model.selectedAccountsSettings;
		}
	}

	goToMakePayment() {
		let routeSettings: SinglePaymentRouteSettings = new SinglePaymentRouteSettings();
		routeSettings.payInFull = false;
		routeSettings.selectedCustomerAccountKeys = this.selectedAccounts.map(x => x.customerAccountKey);
		this.router.routes.find((routeConfig) => routeConfig.name === 'single-payment/single-payment').settings = routeSettings;
		this.router.navigateToRoute('single-payment/single-payment');
	}
}
